/** Scroll to a section id on the single-page home (e.g. "services", "home"). */
export function scrollToSectionId(id) {
  const key = String(id || '').toLowerCase();
  if (key === 'home' || key === '') {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    return;
  }
  const el = document.getElementById(key);
  if (el) el.scrollIntoView({ behavior: 'smooth' });
}
